import {Component} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Barrel, BarrelsV1Service, Department, ToastLevel, WoodType} from "../../../apis/backend";
import {BehaviorSubject, firstValueFrom} from "rxjs";
import {ToastLevelDisplayValues} from "../utils/toast-level";
import {WoodTypeDisplayValues} from "../utils/wood-type";

@Component({
    selector: 'barrel-dialog',
    templateUrl: './barrel-dialog.component.html',
})
export class BarrelDialogComponent {

    public ToastLevelValues: ToastLevel[];
    public ToastLevelDisplayValues = ToastLevelDisplayValues;
    
    public WoodTypeValues: WoodType[];
    public WoodTypeDisplayValues = WoodTypeDisplayValues;

    public Barrel: Barrel = <Barrel>{};
    
    constructor(
        public ActiveModal: NgbActiveModal,
        public BarrelApiService: BarrelsV1Service) {
        this.ToastLevelValues = <ToastLevel[]>Object.values(ToastLevel);
        this.WoodTypeValues = <WoodType[]>Object.values(WoodType);
    }

    public ParseDate(dateStr: string) {
        return new Date(dateStr);
    }
    
    public Save() {
        this.ActiveModal.close(this.Barrel);
    }
    
    public Cancel() {
        this.ActiveModal.dismiss();
    }
}